let basePath = '';
function setBasePath(path) {
    basePath = path;
}
function getBasePath() {
    return basePath.replace(/\/$/, '');
}
export { setBasePath, getBasePath };
const scripts = [...document.getElementsByTagName('script')];
const configScript = scripts.find(script => script.hasAttribute('data-arc'));
if (configScript) {
    setBasePath(configScript.getAttribute('data-arc'));
}
else {
    const fallbackScript = scripts.find(s => /arc(\.min)?\.js$/.test(s.src));
    let path = '';
    if (fallbackScript) {
        path = fallbackScript.getAttribute('src');
    }
    setBasePath(path.split('/').slice(0, -1).join('/'));
}
